export default {
	title: "Types de rituels",
	spiritualLine: "Lignée spirituelle",
	status: "Statut",
	details: {
		basicInfo: "Informations de base",
		timestamps: "Informations système",
		noData: "Aucune donnée disponible",
	},
	edit: "Modifier le type de rituel",
	create: "Créer un type de rituel",
	activate: "Activer",
	deactivate: "Désactiver",
	notFound: "Type de rituel introuvable",
	deleteConfirmation: "Voulez-vous vraiment supprimer le type de rituel {name} ?",
	form: {
		nameLabel: "Nom du type de rituel",
		nameHint: "Nom qui identifie le type de rituel",
		codeLabel: "Code",
		codeHint: "Rempli à partir du nom — modifiez-le seulement si vous en voulez un autre",
		descriptionLabel: "Description",
		descriptionHint: "Description facultative du type de rituel",
		spiritualLineLabel: "Lignée spirituelle prédominante",
		spiritualLineHint: "Lignée spirituelle qui prédomine dans ce type de rituel",
		isActiveLabel: "Type actif dans le système",
	},
	validation: {
		nameRequired: "Le nom est obligatoire",
		nameMaxLength: "Le nom doit avoir au maximum 100 caractères",
		codeRequired: "Le code est obligatoire",
		codeMaxLength: "Le code doit avoir au maximum 50 caractères",
		codeFormat: "Le code ne doit contenir que des lettres minuscules, des chiffres, des tirets et des tirets bas",
		spiritualLineRequired: "La lignée spirituelle est obligatoire",
		descriptionMaxLength: "La description doit avoir au maximum 500 caractères",
	},
	messages: {
		created: "Type de rituel {name} créé avec succès",
		updated: "Type de rituel {name} mis à jour avec succès",
		deleted: "Type de rituel {name} supprimé avec succès",
		deactivatedWithDeps: "Le type de rituel {name} a des dépendances et a été désactivé",
		activated: "Type de rituel {name} activé avec succès",
		deactivated: "Type de rituel {name} désactivé avec succès",
		createError: "Erreur lors de la création du type de rituel",
		updateError: "Erreur lors de la mise à jour du type de rituel",
		deleteError: "Erreur lors de la suppression du type de rituel",
		loadError: "Erreur lors du chargement des types de rituels",
		toggleError: "Erreur lors du changement de statut du type de rituel",
	},
	noDescription: "Aucune description",
	searchPlaceholder: "Nom, code ou description...",
	loading: "Chargement des détails...",
	table: {
		name: "Nom",
		spiritualLine: "Lignée spirituelle",
		attendanceCards: "Cartes",
		status: "Statut",
		headers: {
			createdAt: "Créé le",
			updatedAt: "Mis à jour le",
		},
	},
	empty: {
		description: "Enregistrez les types de rituels pratiqués dans le temple",
		title: "Aucun type de rituel trouvé",
	},
	filters: {
		status: {
			all: "Tous",
		},
	},
	stats: {
		total: "Total des types",
		active: "Types actifs",
	},
};
